const isfastmode = () => {
    return (() => {
        let isfastmode = 1;

        try {
            localStorage.setItem('checkfastmode', 1);
            isfastmode = 0;
        } catch (e) {
            console.error(e);
        }

        return isfastmode;
    })();
};

const setSession = (key, value) => {
    if (isfastmode()) return '';

    sessionStorage.setItem(key, JSON.stringify(value));
};

const getSession = key => {
    if (isfastmode()) return '';

    return JSON.parse(sessionStorage.getItem(key)) || '';
};

const setlocal = (key, value) => {
    if (isfastmode()) return '';
    localStorage.setItem(key, JSON.stringify(value));
};

const getlocal = key => {
    if (isfastmode()) return '';

    return JSON.parse(localStorage.getItem(key));
};

export {
    setSession,
    getSession,
    setlocal,
    getlocal,
    isfastmode,
};

export default {
    setSession,
    getSession,
    setlocal,
    getlocal,
    isfastmode,
};
